import type { TFunction } from 'i18next';

/**
 * The words said when a record's source has processing paused or withdrawn
 * (#2709): one place for the four screens that refuse a re-analysis or retry
 * (record card, retry from a list, bulk reprocess, media re-check), so they
 * cannot drift apart.
 *
 * With `count` (a bulk run refused several records) the message names how many,
 * pluralised; without it, the message is the single-record explanation.
 */
export function processingPausedText(
  t: TFunction,
  count?: number
): { title: string; message: string } {
  return {
    title: t('records.processingPaused.title', 'Processing of this source is stopped'),
    message:
      count !== undefined
        ? t('records.start.resultProcessingPausedNote', { count })
        : t(
            'records.processingPaused.message',
            'The recording is stored, but it is not analysed until processing of its source is resumed.'
          ),
  };
}

/** Tells the reader why nothing was started — an answer, not an error. */
export function toastProcessingPaused(
  toast: { info: (title: string, description?: string) => void },
  t: TFunction,
  count?: number
): void {
  const { title, message } = processingPausedText(t, count);
  toast.info(title, message);
}
